// extracted by mini-css-extract-plugin
module.exports = {"moreinfo":"Moreinfo_moreinfo__6f8jJ","moreinfo-phone":"Moreinfo_moreinfo-phone__lqguR","moreinfo-email":"Moreinfo_moreinfo-email__z321c"};